"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _DraftHeader = _interopRequireDefault(require("../DraftHeader"));
var _hooks = require("../hooks");
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.728 2.88a3.013 3.013 0 0 1 4.257 0l2.133 2.13a3.005 3.005 0 0 1 0 4.254l-2.412 2.406-9.186 9.172a1 1 0 0 1-.526.276l-4.626.849a2.005 2.005 0 0 1-2.34-2.301l.77-4.613a1 1 0 0 1 .28-.543l9.239-9.223 2.41-2.407zM18 9.55l1.704-1.701a1.005 1.005 0 0 0 0-1.424l-2.132-2.13a1.014 1.014 0 0 0-1.431 0l-1.702 1.7L18 9.55zm-4.977-2.143L4.718 15.7 4 19.995v.002h.001l.003.003h.003l4.32-.793 8.258-8.244-3.562-3.556z"
  }));
};
EditIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var DraftHeaderEditMode = function DraftHeaderEditMode(_ref) {
  var hasUnpublishedChanges = _ref.hasUnpublishedChanges,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var isCreatingDraft = !hasUnpublishedChanges;
  var _useEditModeActions = (0, _hooks.useEditModeActions)(hasUnpublishedChanges),
    publishedURL = _useEditModeActions.publishedURL,
    onCancel = _useEditModeActions.onCancel,
    onSave = _useEditModeActions.onSave,
    onPublish = _useEditModeActions.onPublish;
  var buttons = _react.default.useMemo(function () {
    if (isLoading) {
      return [];
    }
    return [{
      title: 'Cancel',
      description: 'Cancel changes',
      onClick: onCancel,
      noFill: true
    }, {
      title: 'Save',
      description: 'Save draft',
      onClick: onSave,
      noFill: true
    }].concat((0, _toConsumableArray2.default)(isCreatingDraft ? [] : [{
      title: 'View published',
      description: 'Return to published documentation',
      href: publishedURL,
      noFill: true
    }]), [{
      title: 'Publish',
      description: 'Publish draft',
      onClick: onPublish,
      noFill: false
    }]);
  }, [isCreatingDraft, isLoading, publishedURL, onCancel, onSave, onPublish]);
  return /*#__PURE__*/_react.default.createElement(_DraftHeader.default, {
    buttons: buttons,
    statusText: isCreatingDraft ? 'Creating a new draft' : 'Editing draft',
    statusIcon: /*#__PURE__*/_react.default.createElement(EditIcon, null)
  });
};
var _default = exports.default = DraftHeaderEditMode;
//# sourceMappingURL=DraftHeaderEditMode.js.map